import React from 'react';
import { useIntl } from '@tink/core/src/components/providers/LanguageProvider/useIntl';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { BalancedText } from '@tink/core/src/components/atoms/BalancedText/BalancedText';
import { FormattedMessage } from 'react-intl';
import { rejectFailedOrCancelledPayment } from '../../models/payment';
import { PageView } from '../../../../models/analytics';
import { useConfiguration } from '../../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { VerboseErrorScreen } from '../../../../components/screens/VerboseErrorScreen/VerboseErrorScreen';
import { commonMessages } from '../../../../components/atoms/CommonMessages/messages';
import { Caption, Text } from '../../../../components/atoms/Text/Text';
import { messages as commonMessagesPayment } from '../../../../core/screens/SuccessNotification/molecules/SuccessOverlay/messages';
import { messages } from './messages';

export type PaymentFailureOverlayProps = {
  heading?: string;
  text?: string;
  hint?: string;
  paymentId: string;
  noRetriesHeading?: string;
  primaryButtonText?: string;
  primaryButtonAction: () => void;
  secondaryButtonText?: string;
  secondaryButtonAction?: () => void;
  noRetriesButtonText?: string;
};

export const PaymentFailureOverlay: React.FC<PaymentFailureOverlayProps> = (props) => {
  const { formatMessage } = useIntl();
  const {
    text = formatMessage(messages.text),
    hint = formatMessage(messages.hint),
    primaryButtonText = formatMessage(commonMessages.retry),
    primaryButtonAction,
    secondaryButtonText = formatMessage(messages.terminateFlow),
    secondaryButtonAction,
    noRetriesHeading = formatMessage(messages.noRetriesTitle),
    noRetriesButtonText = formatMessage(commonMessages.ok),
    paymentId,
  } = props;
  const { data: configurationData } = useConfiguration();

  if (rejectFailedOrCancelledPayment(configurationData)) {
    return (
      <VerboseErrorScreen
        viewEvent={PageView.PAYMENT_FAILURE_SCREEN}
        title={noRetriesHeading}
        body={[
          {
            view: (
              <Box>
                <Text size="xsmall" mt="xxsmall" color="secondary">
                  <FormattedMessage {...commonMessagesPayment.paymentId} values={{ paymentId }} />
                </Text>
              </Box>
            ),
          },
        ]}
        primaryAction={secondaryButtonAction}
        primaryButtonText={noRetriesButtonText}
      />
    );
  }

  return (
    <VerboseErrorScreen
      viewEvent={PageView.PAYMENT_FAILURE_SCREEN}
      title={text}
      body={[
        {
          view: (
            <Box mb="medium">
              <Caption>{hint}</Caption>
              <Text size="xsmall" mt="xxsmall" color="secondary">
                <BalancedText>
                  <FormattedMessage {...commonMessagesPayment.paymentId} values={{ paymentId }} />
                </BalancedText>
              </Text>
            </Box>
          ),
        },
      ]}
      primaryAction={primaryButtonAction}
      primaryButtonText={primaryButtonText}
      secondaryAction={secondaryButtonAction}
      secondaryButtonText={secondaryButtonText}
    />
  );
};
